import IconCheck from '@icons/check';
import cn from 'classnames';
import { forwardRef } from 'react';

import styles from './success-message.module.scss';

const SuccessMessage = forwardRef(
  (
    { className, children, ...props }: React.HTMLAttributes<HTMLSpanElement>,
    ref: React.ForwardedRef<HTMLSpanElement>,
  ) => {
    return (
      <span ref={ref} className={cn(styles.container, className)} {...props}>
        <IconCheck className={styles.icon} />
        <span className={styles.message}>{children}</span>
      </span>
    );
  },
);

SuccessMessage.displayName = 'SuccessMessage';

export default SuccessMessage;
